import { Button, Icon } from '@britishcouncil/react-admin';
import { ROUTING_PATHS } from 'const';
import { useIntParam } from 'hooks';
import { Link, generatePath } from 'react-router';

export const AddRoomButton = () => {
  const { addRoomToSpeakingSession } = ROUTING_PATHS;
  const speakingSessionId = useIntParam('sessionId');

  return (
    <Link
      to={generatePath(addRoomToSpeakingSession.absolutePath, {
        sessionId: speakingSessionId,
      })}
      data-testid="add-room-link"
    >
      <Button compact primary>
        <Icon name="plus square" />
        Add room
      </Button>
    </Link>
  );
};
